import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalReachConfig } from './../totalReach';

export const mediaViewerReachRateConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalReachConfig,
    id: 'reach_rate',
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.reach_rate',
    tooltip: null,
    type: 'kpi',
    data_format: KPI_VALUE_PERCENT,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader
};
